// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.lNE4mBazB3rntN_7CnFH {
  width: 100%;
  display: flex;
  margin: 0 1px;
  position: relative;
  padding: 5px 0;
  box-sizing: border-box;
  flex-direction: row;
}

.qoYd9JucoE249bxXYUmj {
  width: 100%;
  height: 8px;
  background-color: var(--background-color);
  border-radius: 10px 0 0 10px;
  display: flex;
  position: absolute;
}

.H9gYU7voVVClAhdS9dAJ {
  position: absolute;
  bottom: "10%";
  border: 1px solid var(--grey-color-70);
  background-color: var(--grey-gradient-start-color-10);
  border-radius: 16px;
  color: var(--grey-color-90);
  text-align: center;
  font-size: 14px;
  height: auto;
  box-sizing: border-box;
  display: flex;
  justify-content: center;
  align-items: center;
  line-height: 20px;
  transform: "translateX(-50%)";
}

.GlAaz38qSxXwMt7EO6j3 {
  height: 100%;
}

.YWNuHvfxPWqE6aytA8ao {
  height: 100%;
  background-color: var(--background-color);
  border: 1px solid var(--grey-color-350);
  border-left: none;
  border-radius: 0px 10px 10px 0px;
}

.t2QSSbhJqpBJtkWYJHWa {
  color: var(--grey-color-70);
}

.sbCdri1rfwTgLfib0aDk {
  display: flex;
  position: relative;
  align-items: baseline;
  margin-top: 25px;
}

.RycTKEL4QVIVYuX2GfpV {
  display: flex;
  flex-direction: row;
  gap: 8px;
}

.xrEpube00AyC_Go7TQ2y {
  display: flex;
  align-items: center;
  max-height: 32px;
  height: 32px;
  position: relative;
  bottom: -4px;
}

.fUYLECsWfnrQkdVqWk36 {
  display: flex;
  gap: 4px;
  align-items: center;
}

.SZ0P8hvkvrhaIVMCedy0 {
  display: flex;
  color: var(--Black, var(--grey-color-90));
  font-family: var(--font-stack-full-regular);
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px;
}

.cPldv2rmDzHYm46taQSF {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  height: 36px;
  width: 100%;
}

.xtou5bp3PmxmqPFNGGSc {
  position: relative;
  width: 100%;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  bottom: -4px;
}

.tN5Bx_hmW9wp3CMq9qux {
  align-items: baseline;
  margin-top: 6px;
}`, "",{"version":3,"sources":["webpack://./src/components/AverageScoreProgressBar/AverageScoreProgressBar.module.scss"],"names":[],"mappings":"AAAA;EACE,WAAA;EACA,aAAA;EACA,aAAA;EACA,kBAAA;EACA,cAAA;EACA,sBAAA;EACA,mBAAA;AACF;;AAEA;EACE,WAAA;EACA,WAAA;EACA,yCAAA;EACA,4BAAA;EACA,aAAA;EACA,kBAAA;AACF;;AAEA;EACE,kBAAA;EACA,aAAA;EACA,sCAAA;EACA,qDAAA;EACA,mBAAA;EACA,2BAAA;EACA,kBAAA;EACA,eAAA;EACA,YAAA;EACA,sBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,iBAAA;EACA,6BAAA;AACF;;AAEA;EACE,YAAA;AACF;;AAEA;EACE,YAAA;EACA,yCAAA;EACA,uCAAA;EACA,iBAAA;EACA,gCAAA;AACF;;AAEA;EACE,2BAAA;AACF;;AAEA;EACE,aAAA;EACA,kBAAA;EACA,qBAAA;EACA,gBAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,YAAA;EACA,kBAAA;EACA,YAAA;AACF;;AAEA;EACE,aAAA;EACA,QAAA;EACA,mBAAA;AACF;;AAEA;EACE,aAAA;EACA,yCAAA;EACA,2CAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AACF;;AAEA;EACE,aAAA;EACA,sBAAA;EACA,qBAAA;EACA,YAAA;EACA,WAAA;AACF;;AAEA;EACE,kBAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;EACA,sBAAA;EACA,uBAAA;EACA,YAAA;AACF;;AAEA;EACE,qBAAA;EACA,eAAA;AACF","sourcesContent":[".boxContainer {\n  width: 100%;\n  display: flex;\n  margin: 0 1px;\n  position: relative;\n  padding: 5px 0;\n  box-sizing: border-box;\n  flex-direction: row;\n}\n\n.barStyle {\n  width: 100%;\n  height: 8px;\n  background-color: var(--background-color);\n  border-radius: 10px 0 0 10px;\n  display: flex;\n  position: absolute;\n}\n\n.targetValueBox {\n  position: absolute;\n  bottom: \"10%\";\n  border: 1px solid var(--grey-color-70);\n  background-color: var(--grey-gradient-start-color-10);\n  border-radius: 16px;\n  color: var(--grey-color-90);\n  text-align: center;\n  font-size: 14px;\n  height: auto;\n  box-sizing: border-box;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  line-height: 20px;\n  transform: \"translateX(-50%)\";\n}\n\n.filledPart {\n  height: 100%;\n}\n\n.unfilledPart {\n  height: 100%;\n  background-color: var(--background-color);\n  border: 1px solid var(--grey-color-350);\n  border-left: none;\n  border-radius: 0px 10px 10px 0px;\n}\n\n.rigthArrow {\n  color: var(--grey-color-70);\n}\n\n.boxesContainerMapping {\n  display: flex;\n  position: relative;\n  align-items: baseline;\n  margin-top: 25px;\n}\n\n.leftSideContainer {\n  display: flex;\n  flex-direction: row;\n  gap: 8px;\n}\n\n.titleWrapper {\n  display: flex;\n  align-items: center;\n  max-height: 32px;\n  height: 32px;\n  position: relative;\n  bottom: -4px;\n}\n\n.titleArrowWrapper {\n  display: flex;\n  gap: 4px; // adjust as needed\n  align-items: center;\n}\n\n.titleStyle {\n  display: flex;\n  color: var(--Black, var(--grey-color-90));\n  font-family: var(--font-stack-full-regular);\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 24px;\n}\n\n.rightSideWrapper {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n  height: 36px;\n  width: 100%;\n}\n\n.rightSideContainer {\n  position: relative;\n  width: 100%;\n  display: flex;\n  align-items: center;\n  flex-direction: column;\n  justify-content: center;\n  bottom: -4px;\n}\n\n.arrowStyle {\n  align-items: baseline;\n  margin-top: 6px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"boxContainer": `lNE4mBazB3rntN_7CnFH`,
	"barStyle": `qoYd9JucoE249bxXYUmj`,
	"targetValueBox": `H9gYU7voVVClAhdS9dAJ`,
	"filledPart": `GlAaz38qSxXwMt7EO6j3`,
	"unfilledPart": `YWNuHvfxPWqE6aytA8ao`,
	"rigthArrow": `t2QSSbhJqpBJtkWYJHWa`,
	"boxesContainerMapping": `sbCdri1rfwTgLfib0aDk`,
	"leftSideContainer": `RycTKEL4QVIVYuX2GfpV`,
	"titleWrapper": `xrEpube00AyC_Go7TQ2y`,
	"titleArrowWrapper": `fUYLECsWfnrQkdVqWk36`,
	"titleStyle": `SZ0P8hvkvrhaIVMCedy0`,
	"rightSideWrapper": `cPldv2rmDzHYm46taQSF`,
	"rightSideContainer": `xtou5bp3PmxmqPFNGGSc`,
	"arrowStyle": `tN5Bx_hmW9wp3CMq9qux`
};
export default ___CSS_LOADER_EXPORT___;
